import { render } from "./IconRefresh.vue?vue&type=template&id=6e7513bb"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconRefresh.vue"]])

export default __exports__